import { login, logout, getInfo, autoLogin } from '@/api/user'
import { getToken, setToken, removeToken, parseTokenRaw } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    intro: '',
    uuid: '',
    user_id: '',
    type: null,
    code: null,
    roles: []
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state,isResetType) => {
    let type;
    if(!isResetType){
      type = state.type;
    }
    Object.assign(state, getDefaultState())
    if(!isResetType){
      state.type = type;
    }
  },
  SET_TOKEN: (state, token) => {
    state.token = parseTokenRaw(token)
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_PROJECT_CODE: (state, code) => {
    state.code = code || null
  },
  REMOVE_PROJECT_CODE:(state)=>{
    state.code = ""
  },
  SET_USER_TYPE: (state, type) => {
    state.type = type
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_INTRO: (state, intro) => {
    state.intro = intro
  },
  SET_UUID: (state, uuid) => {
    state.uuid = uuid
  },
  SET_USER_ID: (state, id) => {
    state.user_id = id
  }
}

const actions = {
  autoLogin1({ commit }) {
    return new Promise((resolve, reject) => {
      autoLogin().then(res => {
        const { data } = res
        commit('SET_TOKEN', data)
        setToken(data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user auto login
  autoLogin({ commit }, token) {
    return new Promise(resolve => {
      removeToken()
      commit('SET_TOKEN', token)
      setToken(token)
      resolve()
    })
  },
  // user login
  login({ commit }, userInfo) {
    const { username, password, captcha, captchaType, pointJson, token } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, captcha: captcha, captchaType: captchaType, pointJson: pointJson, token: token }).then(response => {
        // You have been logged out, you can cancel to stay on this page, or log in again
        const { data } = response
        commit('SET_TOKEN', data)
        setToken(data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  loginSms({ commit }, userInfo) {
    // console.log('stor-user-sms',commit)
    const { username, code, captchaType, pointJson, token, isSmsSubmit } = userInfo
    console.log('stor-user-sms', userInfo)
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), code: code.trim(), captchaType: captchaType, pointJson: pointJson, token: token, isSmsSubmit: isSmsSubmit }).then(response => {
        // You have been logged out, you can cancel to stay on this page, or log in again
        console.log('loginsms,res', response)
        const { data } = response
        commit('SET_TOKEN', data)
        setToken(data)
        resolve()
      }).catch(error => {
        console.log('loginsms,res,fail', error)
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, nickname, avatar, intro, uuid, id, type, corp } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', nickname)
        commit('SET_USER_TYPE', type)
        commit('SET_PROJECT_CODE', corp ? corp.code : null)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRO', intro)
        commit('SET_UUID', uuid)
        commit('SET_USER_ID', id)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE',true)
        commit('REMOVE_PROJECT_CODE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit,dispatch }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

